<template>
  <div class='choose-action'>

    <v-row>
      <v-col align="center">
        <h2 id="select-category" class="i-deepblue--text">Welcome</h2>
        <h4 class="i-blue--text">what will you like to do<span class="i-deepblue--text">?</span></h4>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="col-12 pb-0">
        <v-col class="col-12 center depressed i-blue">
          <v-row justify="center">

            <v-scale-transition>
              <v-btn v-if="$keys[0]"
                rounded
                elevation=6
                outlined
                link
                href="#select-category"
                @click="setUserType('advertise')"
                class="i-darkblue i-powderblue--text mr-5 mt-5">
                Advertise
              </v-btn>
            </v-scale-transition>

            <v-scale-transition>
              <v-btn v-if="$keys[0]"
                rounded
                elevation=6
                outlined
                link
                href="#select-category"
                @click="setUserType('rent')"
                class="pr-10 pl-10 i-powderblue--text i-lightrose ml-5 mt-5">
                Hire
              </v-btn>
              </v-scale-transition>
          </v-row>

          <v-slide-x-transition hide-on-leave>
            <div v-if="advertise" class="col-lg-4 col-11 padded-1 center curved">
              <br/>
              <p class="i-powderblue--text">What do you want to adverise?</p>
              <v-list>
                <v-list-item link to="advertise-vehicle">
                  <v-list-item-action>
                    <v-icon large>mdi-car</v-icon>
                  </v-list-item-action>

                  <h3 class="pink--text">Vehicles</h3>
                </v-list-item>

                <v-list-item link to="advertise-property">
                  <v-list-item-action>
                    <v-icon large>mdi-home</v-icon>
                  </v-list-item-action>
                  
                  <h3 class="pink--text">Properties</h3>
                </v-list-item>

                <v-list-item link to="advertise-equipment">
                  <v-list-item-action>
                    <v-icon large>mdi-widgets</v-icon>
                  </v-list-item-action>
                  
                  <h3 class="pink--text">Equipment</h3>
                </v-list-item>
              </v-list>
            </div>
          </v-slide-x-transition>

          <v-slide-x-reverse-transition hide-on-leave>
            <div v-if="rent" class="col-lg-4 col-11 padded-1 center curved">
              <br/>
              <p class="i-powderblue--text">What do you want to hire?</p>
              <v-list>
                <v-list-item link to="vehicle-rentals">
                  <v-list-item-action>
                    <v-icon large>mdi-car</v-icon>
                  </v-list-item-action>

                  <h3 class="pink--text">Vehicles</h3>
                </v-list-item>

                <v-list-item link to="property-rentals">
                  <v-list-item-action>
                    <v-icon large>mdi-home</v-icon>
                  </v-list-item-action>
                  
                  <h3 class="pink--text">Properties</h3>
                </v-list-item>

                <v-list-item link to="equipment-rentals">
                  <v-list-item-action>
                    <v-icon large>mdi-widgets</v-icon>
                  </v-list-item-action>
                  
                  <h3 class="pink--text">Equipment</h3>
                </v-list-item>
              </v-list>
            </div>
          </v-slide-x-reverse-transition>

          <br/>
          <br/>
        </v-col>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'user-category',

  data: () => ({
    source: null,
    advertise: false,
    rent: false
  }),

  computed: {
    mobile () {
      let value
      window.innerWidth <= 760
      ? value = true
      : value = false

      return value
    },
  },

  methods: {
    setUserType (token) {
      if (token === 'advertise') {
        this.advertise = true
        this.rent = false
      } else if (token === 'rent') {
        this.rent = true
        this.advertise = false
      }
    }
  },

  hasAnim: true
}
</script>

<style scoped>
.depressed {
  box-shadow: inset -0.5px 5px 10px 3px var(--darkblue);
  border-radius: 1.5rem 1.5rem 0px 0px;
}

a.v-list-item:hover {
  background: var(--lightblue)
}
</style>
